import { Component } from '@angular/core';

@Component({
  selector: 'signgaze-listing-reviews',
  templateUrl: './listing-reviews.component.html',
  styleUrls: ['./listing-reviews.component.scss'],
})
export class ListingReviewsComponent {
  changingValue = 60;
}
